// extracted by mini-css-extract-plugin
export var completionBody = "_k2-2";
export var completionCard = "_k2-0";
export var completionFooter = "_k2-3";
export var completionTitle = "_k2-1";